/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-bitwise */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef, useState } from 'react';
import {
  FormControl,
  Radio,
  RadioGroup,
  FormControlLabel,
  Grid,
  Card,
  Container,
  Box,
  CardHeader,
  Divider,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { v4 as generateUUID } from 'uuid';
import SignalCellular4BarIcon from '@mui/icons-material/SignalCellular4Bar';
import SignalCellularConnectedNoInternet1BarIcon from '@mui/icons-material/SignalCellularConnectedNoInternet1Bar';
import IconButton from '@mui/material/IconButton';
import axiosInstance from '../../utils/axiosInstance';
import bandwidthHandler from './bandwidthLimiter';
import websocketErrorToString from '../../utils/websocketErrors';
import './webrtcVideo.css';

const PEER_CONNECTION_OPTIONS = { optional: [{ DtlsSrtpKeyAgreement: true }] };
const OFFER_OPTIONS = { offerToReceiveAudio: true, offerToReceiveVideo: true };

let stream;

function Webrtc() {
  const earlyCandidates = useRef([]);
  const pc = useRef();
  const videoRef = useRef();
  const peerId = useRef();
  const bandwidthSelector = useRef();
  const trackAdded = useRef();
  const [ws, setWs] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [widthOfFrame, setWidth] = useState(1280);
  const [heightOfFrame, setHeight] = useState(720);
  const [audioContentHint, setAudioContentHint] = useState('speech');
  const [videoContentHint, setVideoContentHint] = useState('detail');
  const [useOpusAttributes, setUseOpusAttributes] = useState(true);
  const [networkQuality, setNetworkQuality] = useState('');
  const [supportedConstraints, setSupportedConstraints] = useState(null);
  const [opusAttributesJson, setOpusAttributesJson] = useState(
    JSON.stringify(
      {
        stereo: 0,
        'sprop-stereo': 1,
        maxaveragebitrate: 126000,
        maxplaybackrate: 126000,
        cbr: 0,
        useinbandfec: 1,
        usedtx: 1,
      },
      null,
      4
    )
  );
  const [useVideoBitrate, setUseVideoBitrate] = useState(false);
  const [videoBitrate, setVideoBitrate] = useState(
    JSON.stringify(
      {
        min: 2000,
        max: 2000,
      },
      null,
      4
    )
  );
  const [dynamicConstraints, setDynamicConstraints] = useState(
    JSON.stringify({
      width: { exact: 1280 },
      height: { exact: 720 },
    })
  );
  const [enableAudio, setEnableAudio] = useState(true);
  const [enableVideo, setEnableVideo] = useState(true);
  const [frameRate, setFrameRate] = useState(30);
  const videoContentRef = useRef();
  const audioContentRef = useRef();
  const audioOptionRef = useRef();
  const videoOptionRef = useRef();
  const audioSrcRef = useRef();
  const videoSrcRef = useRef();
  const audioOutRef = useRef();
  const frameRateRef = useRef();
  const videoRef_ = useRef();
  const fpsInterval = useRef();

  const hostList = useSelector((state) => state.app.hostList);
  const publicIpAddr = useSelector((state) => state.app.publicIp);
  const [vstDevice, setVstDevice] = useState(hostList.length > 0 ? hostList[0] : null);

  const audioBitrate = useRef();
  const degradationPreference = useRef('resolution');
  const maxFps = useRef();

  const getVstConfig = async () => {
    await axiosInstance
      .get(`${window.location.protocol}//${vstDevice}/api/v1/streambridge/configuration`)
      .then((response) => {
        console.log(response.data);
        // read VST settings and set webrtc sender parameters
        const vstSettings = response.data;
        if (Object.prototype.hasOwnProperty.call(vstSettings, 'webrtc_in_audio_sender_max_bitrate')) {
          audioBitrate.current = vstSettings.webrtc_in_audio_sender_max_bitrate;
        }
        if (Object.prototype.hasOwnProperty.call(vstSettings, 'webrtc_in_video_degradation_preference')) {
          degradationPreference.current = vstSettings.webrtc_in_video_degradation_preference;
        }
        if (Object.prototype.hasOwnProperty.call(vstSettings, 'webrtc_in_video_sender_max_framerate')) {
          maxFps.current = vstSettings.webrtc_in_video_sender_max_framerate;
        }
        window.minBitrate = response.data.webrtc_min_birate || 0;
        window.maxBitrate = response.data.webrtc_max_birate || 0;
        window.startBitrate = response.data.webrtc_start_birate || 0;
        console.log('audioBitrate', audioBitrate.current);
        console.log('degradationPreference', degradationPreference.current);
        console.log('maxFps', maxFps.current);
        console.log('using bitrates', window.minBitrate, window.maxBitrate, window.startBitrate);
      })
      .catch((rejectedValueOrSerializedError) => {
        console.error(rejectedValueOrSerializedError);
      });
  };

  const monitorOutboundFps = () => {
    let fpsSum = 0;
    let fpsCount = 0;
    const incrementFps = (fps) => {
      fpsSum += fps;
      // eslint-disable-next-line no-plusplus
      fpsCount++;
    };
    fpsInterval.current = setInterval(() => {
      if (!pc.current || !pc.current.getStats) {
        incrementFps(0);
        return;
      }
      pc.current
        .getStats(null)
        .then((stats) => {
          stats.forEach((report) => {
            if (report.type === 'outbound-rtp' && report.kind === 'video') {
              if (Object.prototype.hasOwnProperty.call(report, 'framesPerSecond')) {
                const fps = report.framesPerSecond;
                console.info('outbound fps: ', fps);
                incrementFps(fps);
              } else {
                incrementFps(0);
              }
            }
          });
        })
        .catch((error) => {
          console.error('Error getting stats:', error);
        });
    }, 1000);
    setTimeout(() => {
      clearInterval(fpsInterval.current);
      const averageFps = fpsCount > 0 ? fpsSum / fpsCount : 0;
      console.info('Average outbound fps: ', averageFps);
      // Fake video stream by chrome is locked at 20 fps
      if (averageFps >= 17 && averageFps <= 35) {
        console.debug('Average outbound fps: ', averageFps);
      }
    }, 60000);
  };

  const monitorInboundFps = () => {
    let fpsSum = 0;
    let fpsCount = 0;
    const incrementFps = (fps) => {
      fpsSum += fps;
      // eslint-disable-next-line no-plusplus
      fpsCount++;
    };
    fpsInterval.current = setInterval(() => {
      if (!pc.current || !pc.current.getStats) {
        incrementFps(0);
        return;
      }
      pc.current
        .getStats(null)
        .then((stats) => {
          stats.forEach((report) => {
            if (report.type === 'inbound-rtp' && report.kind === 'video') {
              if (Object.prototype.hasOwnProperty.call(report, 'framesPerSecond')) {
                const fps = report.framesPerSecond;
                console.info('inbound fps: ', fps);
                incrementFps(fps);
              } else {
                incrementFps(0);
              }
            }
          });
        })
        .catch((error) => {
          console.error('Error getting stats:', error);
        });
    }, 1000);
    setTimeout(() => {
      clearInterval(fpsInterval.current);
      const averageFps = fpsCount > 0 ? fpsSum / fpsCount : 0;
      console.info('Average inbound fps: ', averageFps);
      if (averageFps >= 20 && averageFps <= 35) {
        console.debug('Average inbound fps: ', averageFps);
      }
    }, 60000);
  };

  const handleRecording = async () => {
    await getVstConfig();
    const audioSource = audioSrcRef.current.value;
    const videoSource = videoSrcRef.current.value;
    let constraints;
    if (widthOfFrame != null) {
      constraints = {
        video: {
          width: { exact: widthOfFrame },
          height: { exact: heightOfFrame },
          deviceId: videoSource ? { exact: videoSource } : undefined,
          frameRate: {
            ideal: Number(frameRate),
            max: Number(frameRate),
          },
        },
        audio: {
          deviceId: audioSource ? { exact: audioSource } : undefined,
          echoCancellation: true,
        },
      };
    } else {
      constraints = {
        video: {
          deviceId: videoSource ? { exact: videoSource } : undefined,
          frameRate: {
            ideal: Number(frameRate),
            max: Number(frameRate),
          },
        },
        audio: {
          deviceId: audioSource ? { exact: audioSource } : undefined,
          echoCancellation: true,
        },
      };
    }

    try {
      if (!enableAudio) {
        delete constraints.audio;
      }
      if (!enableVideo) {
        delete constraints.video;
      }
      console.log('constraints: ', constraints);
      navigator.mediaDevices
        .getUserMedia(constraints)
        // eslint-disable-next-line no-use-before-define
        .then(startWebrtcConnection)
        .catch((err) => {
          console.log('Failed to access mic', err);
          enqueueSnackbar(`Failed to invoke getUserMedia, ${err.name}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        });
    } catch (error) {
      enqueueSnackbar(`Failed to invoke getUserMedia`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      console.error('Failed to invoke get user media');
    }
  };

  const addIceCandidate = (candidate) => {
    const jsonData = {
      peerId: pc.current.peerId.toString(),
      candidate,
    };
    console.debug('calling api/addIceCandidate with ', jsonData);
    axiosInstance
      .post(`${window.location.protocol}//${vstDevice}/api/v1/streambridge/iceCandidate`, jsonData)
      .then((response) => {
        console.log('added ice candidate ?', response.data);
      })
      .catch((e) => {
        console.error('addIceCandidate error', e);
      });
  };

  const onReceiveCandidate = (response) => {
    const candidates = response.data;
    console.debug(`Received candidates from VMS: ${JSON.stringify(candidates)}`);
    if (candidates) {
      console.debug('Creating RTCIceCandidate from each received candidate..');
      for (let i = 0; i < candidates.length; i += 1) {
        const candidate = new RTCIceCandidate(candidates[i]);

        console.debug(`Adding ICE candidate - ${i} :${JSON.stringify(candidate)}`);
        pc.current.addIceCandidate(
          candidate,
          () => {
            console.debug(`addIceCandidate OK - ${i}`);
          },
          (error) => {
            console.debug(`addIceCandidate error - ${i}`, error);
          }
        );
      }
    }
  };

  const getIceCandidate = () => {
    console.debug('calling api/getIceCandidate');
    axiosInstance
      .get(`${window.location.protocol}//${vstDevice}/api/v1/streambridge/iceCandidate?peerId=${pc.current.peerId}`)
      .then(onReceiveCandidate)
      .catch((e) => {
        console.error('getIceCandidate error', e);
      });
  };

  const handleVstDeviceChange = (e) => {
    setVstDevice(e.target.value);
  };

  const changeConstraints = async () => {
    const videoTrack = stream.getVideoTracks()[0];
    // Create a new set of constraints
    const newConstraints = JSON.parse(dynamicConstraints);
    // Apply the new constraints using applyConstraints() method
    await videoTrack.applyConstraints(newConstraints);
  };

  const setRemoteDescription = (sessionDescriptionAnswer) => {
    if (useOpusAttributes) {
      let params = {};
      try {
        params = JSON.parse(opusAttributesJson);
      } catch (error) {
        enqueueSnackbar(`Invalid json for opus attributes`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      }
      sessionDescriptionAnswer.sdp = bandwidthHandler.setOpusAttributes(sessionDescriptionAnswer.sdp, params);
    }
    if (useVideoBitrate) {
      let params = {};
      try {
        params = JSON.parse(videoBitrate);
      } catch (error) {
        enqueueSnackbar(`Invalid json for video attributes`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      }
      sessionDescriptionAnswer.sdp = bandwidthHandler.setVideoBitrates(sessionDescriptionAnswer.sdp, params);
    }
    console.log(sessionDescriptionAnswer.sdp);
    pc.current
      .setRemoteDescription(new RTCSessionDescription(sessionDescriptionAnswer))
      .then(() => {
        earlyCandidates.current.forEach(addIceCandidate);
        getIceCandidate();
      })
      .catch((e) => {
        console.error('onReceiveCall: ', e);
      });
  };

  const reNegotiate = (event) => {
    const json = JSON.parse(event.data);
    if (!json) {
      console.log('Received empty data, skipping');
      return;
    }
    if (!Object.prototype.hasOwnProperty.call(json, 'sdp')) {
      console.log('sdp not present, skipping');
      return;
    }
    pc.current
      .setRemoteDescription(new RTCSessionDescription(json))
      .then(() => {
        console.log('setRemoteDescription complete, creating answer');
        pc.current
          .createAnswer()
          .then((sessionDescription) => {
            console.log('createAnswer complete, setLocalDescription');
            enqueueSnackbar(`createAnswer complete, setLocalDescription`, {
              variant: 'success',
              anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            });
            pc.current
              .setLocalDescription(sessionDescription)
              .then(() => {
                console.log('setLocalDescription complete, sendAnswer');
                enqueueSnackbar(`setLocalDescription complete, sendAnswer`, {
                  variant: 'success',
                  anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
                });
                const answerPayload = {
                  sessionDescription: pc.current.localDescription,
                };
                axiosInstance
                  .post(
                    `${window.location.protocol}//${vstDevice}/api/v1/streambridge/setAnswer?peerId=${pc.current.peerId.toString()}`,
                    answerPayload
                  )
                  .then(() => {
                    console.log('setAnswer success');
                    enqueueSnackbar(`setAnswer success`, {
                      variant: 'success',
                      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
                    });
                    setTimeout(() => {
                      monitorInboundFps();
                    }, 5000);
                  })
                  .catch((e) => {
                    console.error('setAnswer error: ', e);
                    enqueueSnackbar(`setAnswer error`, {
                      variant: 'error',
                      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
                    });
                  });
              })
              .catch((e) => {
                console.error('setLocalDescription error: ', e);
                enqueueSnackbar(`setLocalDescription error`, {
                  variant: 'error',
                  anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
                });
              });
          })
          .catch((e) => {
            console.error('createAnswer error: ', e);
            enqueueSnackbar(`createAnswer error`, {
              variant: 'error',
              anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            });
          });
      })
      .catch((e) => {
        console.error('setRemoteDescription error: ', e);
        enqueueSnackbar(`setRemoteDescription error`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      });
  };

  const rewriteSdp = (sdp) => {
    const sdpStringFind = 'a=fmtp:(.*) (.*)';
    let sdpStringReplace = null;
    sdpStringReplace = `a=fmtp:$1 $2;x-google-max-bitrate=${window.maxBitrate};x-google-min-bitrate=${window.minBitrate};x-google-start-bitrate=${window.startBitrate}`;
    let newSDP = sdp.sdp.toString();
    newSDP = newSDP.replace(new RegExp(sdpStringFind, 'g'), sdpStringReplace);
    sdp.sdp = newSDP;
    console.debug('using modified sdp: ', sdp);
    return sdp;
  };

  const connectWebsocket = () => {
    const newWs = new WebSocket(
      `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${
        window.location.host
      }/vms/ws?connectionId=${pc.current.peerId.toString()}`
    );
    newWs.onmessage = reNegotiate;
    newWs.onerror = (event) => {
      enqueueSnackbar(`Websocket error, ${websocketErrorToString(event.code)}`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      // Ignore SSL errors
      if (event.type === 'error' && ws && ws.readyState === WebSocket.CONNECTING) {
        console.warn('Ignoring SSL error...');
        return;
      }
      console.error(event);
    };
    setWs(newWs);
  };

  const disConnectWebsocket = () => {
    if (ws) {
      ws.close();
    }
    setWs(null);
  };

  const sendSessionDescriptionToVst = (sessionDescription) => {
    const sessionDescriptionPayload = {
      clientIpAddr: publicIpAddr,
      peerId: pc.current.peerId.toString(),
      isClient: true,
      options: {
        quality: 'auto',
        rtptransport: 'udp',
        timeout: 60,
      },
      sessionDescription,
    };
    console.debug('Payload of stream start: ', sessionDescriptionPayload);
    axiosInstance
      .post(`${window.location.protocol}//${vstDevice}/api/v1/streambridge/stream/start`, sessionDescriptionPayload)
      .then((response) => {
        const sessionDescriptionAnswer = response.data;
        window.webrtcSenderDeviceId = response.data.deviceId;
        window.webrtcSenderHost = vstDevice;
        console.debug('Received response of stream start: ', sessionDescriptionAnswer);
        console.debug('Signaling state is ', pc.current.signalingState);
        if (pc.current.signalingState === 'have-local-offer') {
          console.debug('OK signalingState');
        } else {
          console.debug('unexpected signalingState');
        }
        setRemoteDescription(sessionDescriptionAnswer);
        connectWebsocket();
      })
      .catch((e) => {
        console.error('wertc error: ', e);
        enqueueSnackbar(`e.response.data.error_message`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
        // eslint-disable-next-line no-use-before-define
      });
  };

  const createOffer = () => {
    // add tracks before creating offer
    stream.getTracks().forEach((track) => pc.current.addTrack(track, stream));
    pc.current
      .createOffer(OFFER_OPTIONS)
      .then((sessionDescription) => {
        if (window.minBitrate !== 0 && window.startBitrate !== 0 && window.maxBitrate !== 0) {
          sessionDescription = rewriteSdp(sessionDescription);
        }
        console.debug('session Description', sessionDescription);
        pc.current.setLocalDescription(sessionDescription);
        return sessionDescription;
      })
      .then((sessionDescription) => {
        sendSessionDescriptionToVst(sessionDescription);
      })
      .catch((error) => {
        console.error('Failed to create offer', error);
      });
  };

  const onConnectionStateChange = () => {
    // FireFox does not support onConnectionStateChange event
    console.info('connection state change: ', pc.current.connectionState);
    if (pc.current.connectionState === 'disconnected') {
      console.debug('Lost peer connection...');
    }
  };

  const onSignalingStateChange = () => {
    console.info('signaling state change: ', pc.current.signalingState);
  };

  const onIceGatheringStateChange = () => {
    console.info('gathering state change: ', pc.current.iceGatheringState);
  };

  const onIceCandidateError = (e) => {
    console.debug('onIceCandidateError: ', e);
    if (e.errorCode !== 701) {
      console.error(`${e.errorText} error code ${e.errorCode} and url ${e.url}`, 'onIceCandidateError');
    }
    if (e.errorCode === 701) {
      console.debug('error code is 701 that means DNS failed for ipv6, harmless error');
    }
  };

  const onIceConnectionStateChange = () => {
    console.info('ice connection state change: ', pc.current.iceConnectionState);
    if (pc.current && pc.current.iceConnectionState === 'new') {
      getIceCandidate();
    }
    if (pc.current && pc.current.iceConnectionState === 'connected') {
      monitorOutboundFps();
    }
    if (navigator.userAgent.indexOf('Firefox') !== -1 && pc.current.iceConnectionState === 'disconnected') {
      console.debug('ICE connection failed, restart at this point');
    }

    // if failed state recevied that means Webrtc stops doing anything.
    // Must reinitiate connection on failed state

    // iceConnectionState does not goes to failed state in case of chrome. Instead connection state changes to failed.
    // This behaviour is opposite in case of Chromium based browsers like Edge and Chrome
    if (pc.current.iceConnectionState === 'failed' && navigator.userAgent.indexOf('Firefox') !== -1) {
      console.debug('ICE connection failed, restart at this point');
    }
  };

  const onIceCandidate = (event) => {
    if (!event.candidate) {
      console.debug('received null candidate, that means its the last candidate');
      return;
    }
    if (event.candidate) {
      if (event.candidate.candidate.length === 0) {
        console.debug('Recevived empty string for candidate - client is firefox');
        return;
      }
      console.debug('received candidate inside onIceCandidate callback: ', event.candidate.candidate);
      // If a srflx candidate was found, notify that the STUN server works!
      if (event.candidate.type === 'srflx') {
        console.debug('The STUN server is reachable for this candidate!');
        console.debug(`Public IP Address is: ${event.candidate.address}`);
      }
      // If a relay candidate was found, notify that the TURN server works!
      if (event.candidate.type === 'relay') {
        console.debug('The TURN server is reachable for this candidate!');
      }
      if (pc.current && pc.current.currentRemoteDescription) {
        addIceCandidate(event.candidate);
      } else {
        earlyCandidates.current.push(event.candidate);
      }
    }
  };

  const onTrack = (event) => {
    const [stream] = event.streams;
    console.log('onTrack callback');
    videoRef_.current.srcObject = stream;
    videoRef_.current.play();
  };

  const createRTCPeerConnection = (iceServers) => {
    console.debug('ICE Servers: ', iceServers);
    const dataChannelOptions = {
      ordered: false, // do not guarantee order
      maxPacketLifeTime: 3000, // in milliseconds
    };

    try {
      const peerConnection = new RTCPeerConnection({ iceServers }, PEER_CONNECTION_OPTIONS);
      peerConnection.peerId = peerId.current;
      peerConnection.onicecandidate = onIceCandidate;
      peerConnection.oniceconnectionstatechange = onIceConnectionStateChange;
      peerConnection.onicecandidateerror = onIceCandidateError;
      peerConnection.onicegatheringstatechange = onIceGatheringStateChange;
      peerConnection.onsignalingstatechange = onSignalingStateChange;
      peerConnection.onconnectionstatechange = onConnectionStateChange;
      peerConnection.ontrack = onTrack;
      pc.current = peerConnection;

      // data channel
      const dataChannel = peerConnection.createDataChannel('tokkio-ui-data-channel', dataChannelOptions);
      dataChannel.onerror = (error) => {
        console.log('Data Channel Error:', error);
        enqueueSnackbar('Data channel disconnected', { variant: 'error' });
      };
      dataChannel.onmessage = (event) => {
        // FORMAT: {"message_catogory":"network_qos","message_type":"alert","network_bandwidth_state":"low"}
        try {
          const alertMessage = JSON.parse(event.data);
          if (alertMessage.network_bandwidth_state === 'low' || alertMessage.network_bandwidth_state === 'high') {
            console.log('network quality: ', alertMessage.network_bandwidth_state);
            setNetworkQuality(alertMessage.network_bandwidth_state);
          }
        } catch (error) {
          console.log('failed to parse data channel message');
        }
      };
      dataChannel.onclose = () => {
        console.log('The Data Channel is Closed');
        enqueueSnackbar('Data channel closed', { variant: 'error' });
      };
      window.webrtcSenderPeerConnection = peerId.current;
    } catch (error) {
      console.error(`Failed to create RTC peer connection.`, error);
    }
    createOffer();
  };

  const onDeviceFetch = () => {
    console.log('Stream ', stream);
    peerId.current = generateUUID();
    axiosInstance
      .get(`${window.location.protocol}//${vstDevice}/api/v1/streambridge/iceServers?peerId=${peerId.current}`)
      .then((response) => {
        console.log(response.data);
        createRTCPeerConnection(response.data.iceServers);
      })
      .catch((rejectedValueOrSerializedError) => {
        console.error(rejectedValueOrSerializedError);
      });
  };

  const startWebrtcConnection = (CameraStream) => {
    videoRef.current.srcObject = CameraStream;
    const videoTracks = CameraStream.getVideoTracks();
    const audioTracks = CameraStream.getAudioTracks();
    if (videoTracks.length > 0) {
      console.log(`Using video device: ${videoTracks[0].label}`);
    }
    if (audioTracks.length > 0) {
      console.log(`Using audio device: ${audioTracks[0].label}`);
    }
    videoTracks.forEach(async (track) => {
      console.log('videoContentHint: ', videoContentHint);
      track.contentHint = videoContentHint;
      console.log('video track: ', track);
    });
    audioTracks.forEach(async (track) => {
      console.log('audioContentHint: ', audioContentHint);
      track.contentHint = audioContentHint;
      console.log('audio track: ', track);
    });
    audioOptionRef.current.disabled = false;
    videoOptionRef.current.disabled = false;
    stream = CameraStream;
    bandwidthSelector.current.disabled = false;
    onDeviceFetch();
  };

  const stopWebrtcConnection = () => {
    if (pc.current != null) {
      const jsonData = {
        peerId: pc.current.peerId.toString(),
      };
      pc.current.close();
      pc.current = null;
      peerId.current = null;
      earlyCandidates.current = [];
      if (videoRef.current) {
        videoRef.current.srcObject = null;
      }
      if (videoRef_.current) {
        videoRef_.current.srcObject = null;
      }
      try {
        stream.getTracks().forEach((track) => {
          track.stop();
        });
      } catch (error) {
        console.log(error);
      }
      console.debug('calling api/v1/streambridge/stream/stop with ', jsonData);
      axiosInstance
        .post(`${window.location.protocol}//${vstDevice}/api/v1/streambridge/stream/stop`, jsonData)
        .then((response) => {
          console.log('stream stop ?', response.data);
        })
        .catch((e) => {
          console.error('stream stop error', e);
        });
      trackAdded.current = null;
      disConnectWebsocket();
    }
  };

  const triggerDynamicTrack = () => {
    if (pc.current != null && !trackAdded.current && ws) {
      const wssPayload = {
        peerid: pc.current.peerId.toString(),
        apiKey: 'addDummyUdpTrack',
      };
      console.log('Sending Add track to VST');
      enqueueSnackbar(`Sending Add track to VST`, {
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      ws.send(JSON.stringify(wssPayload));
      trackAdded.current = true;
    } else {
      console.error('Track add error, pc null, websocket not connected or track already added');
      enqueueSnackbar(`Track add error, pc null, websocket not connected or track already added`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
    }
  };

  function gotDevices(deviceInfos) {
    // Handles being called several times to update labels. Preserve values.
    const selectors = [audioSrcRef.current, audioOutRef.current, videoSrcRef.current];
    const values = selectors.map((select) => select.value);
    selectors.forEach((select) => {
      while (select.firstChild) {
        select.removeChild(select.firstChild);
      }
    });
    for (let i = 0; i !== deviceInfos.length; i += 1) {
      const deviceInfo = deviceInfos[i];
      const option = document.createElement('option');
      option.value = deviceInfo.deviceId;
      if (deviceInfo.kind === 'audioinput') {
        option.text = deviceInfo.label || `microphone ${audioSrcRef.current.length + 1}`;
        audioSrcRef.current.appendChild(option);
      } else if (deviceInfo.kind === 'audiooutput') {
        option.text = deviceInfo.label || `speaker ${audioOutRef.current.length + 1}`;
        audioOutRef.current.appendChild(option);
      } else if (deviceInfo.kind === 'videoinput') {
        option.text = deviceInfo.label || `camera ${videoSrcRef.current.length + 1}`;
        videoSrcRef.current.appendChild(option);
      } else {
        console.log('Some other kind of source/device: ', deviceInfo);
      }
    }
    selectors.forEach((select, selectorIndex) => {
      if (Array.prototype.slice.call(select.childNodes).some((n) => n.value === values[selectorIndex])) {
        select.value = values[selectorIndex];
      }
    });
  }

  // Attach audio output device to video element using device/sink ID.
  function attachSinkId(element, sinkId) {
    if (typeof element.sinkId !== 'undefined') {
      element
        .setSinkId(sinkId)
        .then(() => {
          console.log(`Success, audio output device attached: ${sinkId}`);
        })
        .catch((error) => {
          let errorMessage = error;
          if (error.name === 'SecurityError') {
            errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`;
          }
          console.error(errorMessage);
          // Jump back to first output device in the list as it's the default.
          videoSrcRef.current.selectedIndex = 0;
        });
    } else {
      console.warn('Browser does not support output device selection.');
    }
  }

  function changeAudioDestination() {
    const audioDestination = audioOutRef.current.value;
    attachSinkId(videoRef.current, audioDestination);
  }

  useEffect(() => {
    const getDevices = () => {
      try {
        navigator.mediaDevices
          .enumerateDevices()
          .then(gotDevices)
          .catch((e) => {
            console.error(e);
          });
      } catch (error) {
        console.error('Failed to get user devices', error);
      }
    };
    getDevices();
    return () => {
      stopWebrtcConnection();
    };
  }, []);

  const handleEnableAudio = () => {
    if (enableVideo) setEnableAudio(!enableAudio);
  };

  const handleEnableVideo = () => {
    if (enableAudio) setEnableVideo(!enableVideo);
  };

  const handleEnableWebrtcLimiter = () => {
    setUseOpusAttributes((useOpusAttributes) => !useOpusAttributes);
  };

  const handleVideoBitrate = () => {
    setUseVideoBitrate((useVideoBitrate) => !useVideoBitrate);
  };

  // renegotiate bandwidth on the fly.
  const onChangeBandwidth = () => {
    console.log('changing bw');
    bandwidthSelector.current.disabled = true;
    const bandwidth = bandwidthSelector.current.options[bandwidthSelector.current.selectedIndex].value;

    // In Chrome, use RTCRtpSender.setParameters to change bandwidth without
    // (local) renegotiation. Note that this will be within the envelope of
    // the initial maximum bandwidth negotiated via SDP.
    if ('RTCRtpSender' in window && 'setParameters' in window.RTCRtpSender.prototype) {
      console.log('RTCRtpSender present..');
      const sender = pc.current.getSenders()[0];
      const parameters = sender.getParameters();
      if (!parameters.encodings) {
        parameters.encodings = [{}];
      }
      if (bandwidth === 'unlimited') {
        delete parameters.encodings[0].maxBitrate;
      } else {
        parameters.encodings[0].maxBitrate = bandwidth * 1000;
      }
      sender
        .setParameters(parameters)
        .then(() => {
          console.log('Done..');
          bandwidthSelector.current.disabled = false;
        })
        .catch((e) => console.error(e));
      return;
    }
    // Fallback to the SDP munging with local renegotiation way of limiting
    // the bandwidth.
    pc.current
      .createOffer()
      .then((offer) => pc.current.setLocalDescription(offer))
      .then(() => {
        const desc = {
          type: pc.current.remoteDescription.type,
          sdp:
            bandwidth === 'unlimited'
              ? removeBandwidthRestriction(pc.current.remoteDescription.sdp)
              : updateBandwidthRestriction(pc.current.remoteDescription.sdp, bandwidth),
        };
        console.log(`Applying bandwidth restriction to setRemoteDescription:\n${desc.sdp}`);
        return pc.current.setRemoteDescription(desc);
      })
      .then(() => {
        bandwidthSelector.current.disabled = false;
      })
      .catch((e) => {
        console.error(e);
      });
  };

  function updateBandwidthRestriction(sdp, bandwidth) {
    let modifier = 'AS';
    if (navigator.userAgent.indexOf('Firefox') !== -1) {
      bandwidth = (bandwidth >>> 0) * 1000;
      modifier = 'TIAS';
    }
    if (sdp.indexOf(`b=${modifier}:`) === -1) {
      // insert b= after c= line.
      sdp = sdp.replace(/c=IN (.*)\r\n/, `c=IN $1\r\nb=${modifier}:${bandwidth}\r\n`);
    } else {
      sdp = sdp.replace(new RegExp(`b=${modifier}:.*\r\n`), `b=${modifier}:${bandwidth}\r\n`);
    }
    return sdp;
  }

  function removeBandwidthRestriction(sdp) {
    return sdp.replace(/b=AS:.*\r\n/, '').replace(/b=TIAS:.*\r\n/, '');
  }

  const restartWebrtcConnection = () => {
    stopWebrtcConnection();
    handleRecording();
  };

  const onConstraints = () => {
    changeConstraints();
  };

  const onGetConstraints = () => {
    const supportedConstraints = navigator.mediaDevices.getSupportedConstraints();
    setSupportedConstraints(supportedConstraints);
  };

  return (
    <Container maxWidth="xl">
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Card>
            <CardHeader title={'Dynamic stream'} subheader={'Dynamic stream'} />
            <Box sx={{ p: 3 }}>
              <video width="100%" height="auto" ref={videoRef_} autoPlay controls muted id="dynamic-stream" />
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card>
            <CardHeader
              title={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  Webcam
                  <IconButton color={networkQuality !== 'high' ? 'error' : 'primary'} sx={{ m: 0, ml: 1, p: 0 }}>
                    {networkQuality !== '' &&
                      (networkQuality === 'high' ? (
                        <SignalCellular4BarIcon />
                      ) : (
                        <SignalCellularConnectedNoInternet1BarIcon />
                      ))}
                  </IconButton>
                </Box>
              }
              subheader={'Webcam stream preview'}
            />
            <Box sx={{ p: 3 }}>
              <video width="100%" height="auto" ref={videoRef} autoPlay controls muted id="webcam-stream" />
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardHeader title={`${window.adaptorType} device`} subheader={'Select VST device to send webcam stream'} />
            <Box sx={{ p: 3 }}>
              <FormControl>
                <RadioGroup row name="vst-device-radio-button" value={vstDevice} onChange={handleVstDeviceChange}>
                  {hostList.map((host) => (
                    <FormControlLabel value={host} control={<Radio />} label={`VST ${host}`} key={host} />
                  ))}
                </RadioGroup>
              </FormControl>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <CardHeader title={'Configuration options'} subheader={'Configuration options'} />
            <Divider sx={{ my: 2 }}>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                Start or stop webrtc sender
              </Typography>
            </Divider>
            <Box p={3} display="flex">
              <LoadingButton
                variant="contained"
                sx={{ margin: 1 }}
                type="primary"
                onClick={restartWebrtcConnection}
                id="start-webrtc-sender"
              >
                Start
              </LoadingButton>
              <LoadingButton
                variant="contained"
                sx={{ margin: 1 }}
                type="primary"
                onClick={stopWebrtcConnection}
                id="stop-webrtc-sender"
              >
                Stop
              </LoadingButton>
              <LoadingButton
                variant="contained"
                sx={{ margin: 1 }}
                type="primary"
                onClick={triggerDynamicTrack}
                id="dynamic-track"
              >
                Dynamic Track
              </LoadingButton>
            </Box>
            <Box sx={{ p: 3 }}>
              <Divider sx={{ my: 2 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  Select input-output devices
                </Typography>
              </Divider>
              <div className="menuCards floatLeft" style={{ margin: 1 }}>
                <label htmlFor="audioSource">
                  <b>Audio input source: </b>
                </label>
                <br />
                <select id="audioSource" ref={audioSrcRef} onChange={() => {}} />
              </div>

              <div className="menuCards floatLeft" style={{ margin: 1 }}>
                <label htmlFor="audioOutput">
                  <b>Audio output destination: </b>
                </label>
                <br />
                <select id="audioOutput" ref={audioOutRef} onChange={changeAudioDestination} />
              </div>

              <div className="menuCards floatLeft" style={{ margin: 1 }}>
                <label htmlFor="videoSource">
                  <b>Video source: </b>
                </label>
                <br />
                <select id="videoSource" ref={videoSrcRef} onChange={() => {}} />
              </div>
              <br />
              <textarea
                value={dynamicConstraints}
                onChange={(e) => setDynamicConstraints(e.target.value)}
                cols="30"
                rows="10"
              />
              <br />
              <Box display="flex">
                <LoadingButton
                  variant="contained"
                  sx={{ margin: 1 }}
                  type="primary"
                  onClick={onConstraints}
                  id="set-constraints"
                >
                  Submit new constraints
                </LoadingButton>
                <LoadingButton
                  variant="contained"
                  sx={{ margin: 1 }}
                  type="primary"
                  onClick={onGetConstraints}
                  id="set-constraints"
                >
                  Get supported constraints
                </LoadingButton>
              </Box>
              <br />
              {supportedConstraints != null && (
                <Box sx={{ p: 3 }}>
                  <ul>
                    {Object.keys(supportedConstraints).map((constraint) => (
                      <li key={constraint}>
                        <code>{constraint}</code>
                      </li>
                    ))}
                  </ul>
                </Box>
              )}
              <a href="https://www.w3.org/TR/mst-content-hint/">constraints doc</a>
              <br />
              <Divider sx={{ my: 2 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  Select content hint
                </Typography>
              </Divider>
              <div className="menuCards floatLeft" style={{ margin: 1 }}>
                <label>ContentHint cant be changed at runtime. Set it before starting stream</label>
                <br />
                <a href="https://www.w3.org/TR/mst-content-hint/">contentHint doc</a>
                <br />
                <label htmlFor="videoContentHint">
                  <b>Video contentHint: </b>
                </label>
                <br />
                <select
                  id="videoContent"
                  defaultValue={'detail'}
                  ref={videoContentRef}
                  onChange={() => setVideoContentHint(videoContentRef.current.value)}
                >
                  <option value="">default</option>
                  <option value="motion">motion</option>
                  <option value="detail">detail</option>
                  <option value="text">text</option>
                </select>
              </div>

              <div className="menuCards floatLeft" style={{ margin: 1 }}>
                <label htmlFor="audioContentHint">
                  <b>Audio contentHint: </b>
                </label>
                <br />
                <select
                  id="audioContent"
                  ref={audioContentRef}
                  defaultValue={'speech'}
                  onChange={() => setAudioContentHint(audioContentRef.current.value)}
                >
                  <option value="">default</option>
                  <option value="speech">speech </option>
                  <option value="speech-recognition">speech-recognition</option>
                  <option value="music">music </option>
                </select>
              </div>
              <Divider sx={{ my: 2 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  Select resolution
                </Typography>
              </Divider>
              <div className="menuCards floatLeft" style={{ display: 'block', width: '100%' }}>
                <p>
                  <b>Resolutions: </b>
                </p>
              </div>
              <LoadingButton
                style={{ margin: 1 }}
                variant={widthOfFrame != null && widthOfFrame === 320 ? 'outlined' : 'contained'}
                onClick={() => {
                  setWidth(320);
                  setHeight(240);
                }}
              >
                QVGA(320x240)
              </LoadingButton>
              <LoadingButton
                style={{ margin: 1 }}
                variant={widthOfFrame != null && widthOfFrame === 640 ? 'outlined' : 'contained'}
                onClick={() => {
                  setWidth(640);
                  setHeight(480);
                }}
              >
                VGA(640x480)
              </LoadingButton>
              <LoadingButton
                style={{ margin: 1 }}
                variant={widthOfFrame != null && widthOfFrame === 1280 ? 'outlined' : 'contained'}
                onClick={() => {
                  setWidth(1280);
                  setHeight(720);
                }}
              >
                HD(1280x720)
              </LoadingButton>
              <br />
              <br />
              <LoadingButton
                style={{ margin: 1 }}
                variant={widthOfFrame != null && widthOfFrame === 1920 ? 'outlined' : 'contained'}
                onClick={() => {
                  setWidth(1920);
                  setHeight(1080);
                }}
              >
                FHD(1920x1080)
              </LoadingButton>
              <LoadingButton
                style={{ margin: 1 }}
                variant={widthOfFrame != null && widthOfFrame === 3840 ? 'outlined' : 'contained'}
                onClick={() => {
                  setWidth(3840);
                  setHeight(2160);
                }}
              >
                Television 4k(3840x2160)
              </LoadingButton>
              <LoadingButton
                style={{ margin: 1 }}
                variant={widthOfFrame != null && widthOfFrame === 4096 ? 'outlined' : 'contained'}
                onClick={() => {
                  setWidth(4096);
                  setHeight(2160);
                }}
              >
                Cinema 4k(4096x2160)
              </LoadingButton>
              <Divider sx={{ my: 2 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  Change bandwidth
                </Typography>
              </Divider>
              <div id="buttons" style={{ margin: 1 }}>
                <label>
                  <b>Change bandwidth on the fly: </b>
                </label>
                <select
                  defaultValue={'unlimited'}
                  id="bandwidth"
                  disabled
                  ref={bandwidthSelector}
                  onChange={onChangeBandwidth}
                >
                  <option value="unlimited">unlimited</option>
                  <option value="2000">20000</option>
                  <option value="2000">16000</option>
                  <option value="2000">12000</option>
                  <option value="2000">8000</option>
                  <option value="2000">4000</option>
                  <option value="2000">2000</option>
                  <option value="1000">1000</option>
                  <option value="500">500</option>
                  <option value="250">250</option>
                  <option value="125">125</option>
                  <option value="75">75</option>
                </select>
                kbps
              </div>
              <Divider sx={{ my: 2 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  Limit Framerate
                </Typography>
              </Divider>
              <div className="menuCards floatLeft" style={{ margin: 1 }}>
                <label htmlFor="audioContentHint">
                  <b>frameRate: </b>
                </label>
                <br />
                <select
                  defaultValue={'30'}
                  id="frameRate"
                  ref={frameRateRef}
                  onChange={() => setFrameRate(frameRateRef.current.value)}
                >
                  <option value="5">5 </option>
                  <option value="10">10 </option>
                  <option value="15">15 </option>
                  <option value="20">20 </option>
                  <option value="25">25 </option>
                  <option value="30">30 </option>
                  <option value="35">35 </option>
                  <option value="40">40 </option>
                  <option value="45">45 </option>
                  <option value="50">50 </option>
                  <option value="55">55 </option>
                  <option value="60">60 </option>
                </select>
              </div>
              <Divider sx={{ my: 2 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  Enable-disable audio-video tracks
                </Typography>
              </Divider>
              <div className="menuCards floatLeft" style={{ margin: 1 }}>
                <label>Enable/Disable audio-video tracks in getUserMedia: </label>
                <br />
                <label>enable audio</label>
                <input type="checkbox" checked={enableAudio} onChange={handleEnableAudio} ref={audioOptionRef} />
                <br />
                <label>enable video</label>
                <input type="checkbox" checked={enableVideo} onChange={handleEnableVideo} ref={videoOptionRef} />
                <Divider sx={{ my: 2 }}>
                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    Change OPUS parameters
                  </Typography>
                </Divider>
                <label>enable Opus attributes</label>
                <input type="checkbox" checked={useOpusAttributes} onChange={handleEnableWebrtcLimiter} />
                <br />
                <label>Opus attributes: </label>
                <br />
                <textarea
                  value={opusAttributesJson}
                  onChange={(e) => setOpusAttributesJson(e.target.value)}
                  cols="30"
                  rows="10"
                  disabled={!useOpusAttributes}
                />
                <br />
                <a href="https://datatracker.ietf.org/doc/html/draft-ietf-payload-rtp-opus-11#section-6.1">
                  Opus attributes doc
                </a>
                <br />
                <label>enable video bitrate</label>
                <input type="checkbox" checked={useVideoBitrate} onChange={handleVideoBitrate} />
                <br />
                <label>Video bitrate settings: </label>
                <br />
                <textarea
                  value={videoBitrate}
                  onChange={(e) => setVideoBitrate(e.target.value)}
                  cols="20"
                  rows="4"
                  disabled={!useVideoBitrate}
                />
                <br />
              </div>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Webrtc;
